import {
    EditViewAction as ControlAction,
    AdminEditViewAction as SavedReportAction,
    AdminEditDeleteAction as UserGroupAction,
    EditAction as UserAction,
    AdminEditViewAction,
    EditViewAction,
    EditAction,
    ControlResultOverviewAction,
    AdminEditViewAction as RiskDirectoryAction,
    AdminEditViewAction as TestingProgramAction,
    StandardAccessRight,
} from "api/generated/model";

const canEditAEV = ({ admin, edit }: AdminEditViewAction): boolean => {
    return admin || edit;
};

const canViewAEV = ({ admin, edit, view }: AdminEditViewAction): boolean => {
    return admin || edit || view;
};

const canEditAE = ({
    admin,
    edit,
}: Pick<AdminEditViewAction, "admin" | "edit">): boolean => {
    return admin || edit;
};

const canViewEV = ({ edit, view }: EditViewAction): boolean => {
    return edit || view;
};

const evActionToAccessRight = (
    action: EditViewAction
): StandardAccessRight | null => {
    if (action.edit) {
        return "Edit";
    } else if (action.view) {
        return "View";
    } else {
        return null;
    }
};

const canEditE = ({ edit }: EditAction): boolean => {
    return edit;
};

/*
 * Saved report
 */

const canEditSavedReport: (actions: SavedReportAction) => boolean = canEditAEV;
const canViewSavedReport: (actions: SavedReportAction) => boolean = canViewAEV;

/*
 * Control
 */

const canViewControl: (actions: ControlAction) => boolean = canViewEV;

const controlActionToAccessRight: (
    actions: ControlAction
) => StandardAccessRight | null = evActionToAccessRight;

/*
 * Testing program
 */

const canViewTestingProgram: (actions: TestingProgramAction) => boolean =
    canViewAEV;

/*
 * User
 */

const canEditUser: (actions: UserAction) => boolean = canEditE;

/*
 * User group
 */

const canEditUserGroup: (actions: UserGroupAction) => boolean = canEditAE;

/*
 * Control result
 */

const canViewControlResult: (actions: ControlResultOverviewAction) => boolean =
    canViewEV;

/*
 * Risk directories
 */
const canViewRiskDirectory: (actions: RiskDirectoryAction) => boolean =
    canViewAEV;

export {
    // Control
    canViewControl,
    controlActionToAccessRight,
    // Testing program
    canViewTestingProgram,
    // User
    canEditUser,
    // User group
    canEditUserGroup,
    // Control result
    canViewControlResult,
    // Saved report
    canEditSavedReport,
    canViewSavedReport,
    // Risk directories
    canViewRiskDirectory,
};
